import React from 'react';
import classNames from 'classnames';
import './Cols.less';

function Cols({data, lg=0, md, lm=1, className, children, ...props}) {
  const renderCol = (data, index) => {
    return React.cloneElement(children, {data, index, key: index});
  };
  const names = ['Cols', `Cols-lg-${lg || md}`, `Cols-md-${md}`, `Cols-lm-${lm}`, className];
  return (
    <div className={classNames(names)} {...props}>
      {data.map(renderCol)}
    </div>
  );
}

export default Cols;


// WEBPACK FOOTER //
// ./src/components/Cols/Cols.js